module.exports = __webpack_public_path__ + "b24dfd979a5bc376e212aa801b93a7cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/footer_mano_text.png
// module id = 226
// module chunks = 0